<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <router-link
        :to="{name: 'paciente',params: { id: data.item.idPaciente }}" >
      <p class="letraColorAzulPrincipal letraEstiloNegrita">
        {{ data.item.nombrePaciente }}
      </p>
    </router-link>
  </div>

</template>

<script>
export default {
    name: "LinkPacientePerfilComponente",
    props: {
        data: Object,
        resource: Object
    },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {
       
    }
}
</script>
